<ng-template cdkPortal #backdropPortal="cdkPortal">
  <div
    class="calendar-backdrop"
    [@transitionBackdrop]="animationState"
    (click)="this.backdropClicked.emit()"
  ></div>
</ng-template>
<ng-template cdkPortal #calendarPortal="cdkPortal">
  <div
    class="calendar-content-wrapper grit-calendar-content-wrapper"
    role="dialog"
    [attr.aria-labelledby]="dialogTitleId"
    #calendar
    [@transitionCalendar]="animationState"
    (@transitionCalendar.done)="onCalendarTransitionDone($event)"
  >
    <div class="opacity-wrapper">
      <div class="calendar-title calendar-padding" [id]="dialogTitleId">
        <ng-content select="[pgLabel], [gritLabel]"></ng-content>
      </div>
      <pg-calendar-actions></pg-calendar-actions>
      <pg-calendar-weekdays></pg-calendar-weekdays>
      <pg-calendar-month></pg-calendar-month>
    </div>
  </div>
</ng-template>
